import { Injectable } from '@angular/core';
import { BaseHttpService } from '../../services/base-http.service';
import { HttpClient, HttpParams } from '@angular/common/http';
import { ConfigService } from '../../services/config.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SearchModalService extends BaseHttpService {
  constructor(
    private superHttp: HttpClient,
    private superConfig: ConfigService
  ) {
    super(superHttp, superConfig);
  }

  public filterByRegion(filter: string): Observable<any> {
    const params = new HttpParams().set('filter', filter);
    return this.http.get<any>(`${this.baseRestURL}forwarding/regions`, {
      params
    });
  }
}
